import * as React from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "./library/Typeahead.css";
import { InputGroup } from "react-bootstrap";
import AutocompleteIncludeExclude from "./library/AutocompleteIncludeExclude";

//**************************************************************************************************
// NOTE: Converted to jsx, because "labelKey" attribute was not correctly detected by typescript definition.
//**************************************************************************************************

//https://github.com/ericgio/react-bootstrap-typeahead
export default function PlacementsAutocomplete (props ) {
  const renderMenuItemChildren = function (option , obj , index) {
    let menuItem = null;

    if ( option.apptapPublisherId !== "ERROR" ){
      menuItem = <span>{option.publisherPlacementName}</span>;
    } else {
      menuItem = (
        <div style={{color : 'red' }}>
          <strong>{option.publisherPlacementName}</strong>
        </div>
      )
    }
    return menuItem;
  }

  // Bypass client-side filtering by returning `true`. Results are already
  // filtered by the search endpoint, so no need to do it again.
  const filterBy = () => true;

  return (
    <InputGroup>
      {
        props.useIncludeExclude ? 
          <AutocompleteIncludeExclude
            defaultIncludeExclude={props.defaultIncludeExclude}
            includeExcludeOnChange={props.includeExcludeOnChange}
            disabled={props.disabled}
          />
        :
          null
      }
      <AsyncTypeahead size="sm"
        id="placementsAutocomplete1"
        renderMenuItemChildren={renderMenuItemChildren}  
        filterBy={filterBy}
        reactKey="placementsAutocomplete2"
        isLoading={props.placementsIsLoading}
        labelKey={(option) => {return option.publisherPlacementName ? option.publisherPlacementName : option.publisherPlacementId;}}
        minLength={3}
        onSearch={props.searchPlacements}
        options={props.options}
        selected={props.selected}
        multiple
        onChange={props.onChange}
        placeholder="Placements (Type 3 letters to perform a search)"
        clearButton
        ref={props.reactRef}
        useCache={false}
        disabled={props.disabled}
      />
    </InputGroup>
  );
};
